export default "__VITE_ASSET__BIJBFUDI__"